/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { BodyLayout } from '@veeam-vspc/shared/components';

import { ExtComponent } from '../../components/Ext/ExtComponent';

export const LocationsPage: React.FC<{}> = () => {
    const xtype = 'rcop.locations.list';

    return (
        <BodyLayout>
            <ExtComponent
                xtype={xtype}
            />
        </BodyLayout>
    );
};
